export const Roles = {
  FinanceInvestor: 'FinanceInvestor',
};